export default __webpack_public_path__ + "static/media/spolexFullLogo.b789063c.png";